import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { T } from "../constants";
import { cx } from "../styles";

/* ---------- Plate chip ---------- */

const usePlate = makeStyles({
  plate: {
    fontWeight: 700,
    background: "#fff",
    color: T.fg,
    border: `1.5px solid ${T.primary}`,
    borderRadius: 8,
    padding: "2px 8px",
    display: "inline-block",
    lineHeight: 1.15,
    whiteSpace: "nowrap",
    fontSize: ({ size }) => size,
  },
});

export default function Plate({ children, size = 12, className }) {
  const c = usePlate({ size });
  return <span className={cx(c.plate, className)}>{children}</span>;
}
